export default __webpack_public_path__ + "static/media/icon-camera.05d077fc.svg";